import { Component, type ReactNode } from 'react'
import { ErrorPage, type ErrorReport } from '@rr/ui'

const APP = 'rr-landing'
const API_URL = (import.meta.env.VITE_API_URL as string) || '/api/v1'

interface State {
  error: Error | null
}

/**
 * Class error boundary for the (router-less) marketing site. Catches render
 * errors and shows the shared `@rr/ui` <ErrorPage>; the "send report" button
 * POSTs to the public `/error-reports` endpoint (no auth on this site).
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  handleReport = async (report: ErrorReport) => {
    const res = await fetch(`${API_URL.replace(/\/$/, '')}/error-reports`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(report),
    })
    if (!res.ok) throw new Error(`Error report failed: ${res.status}`)
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorPage
          app={APP}
          error={this.state.error}
          onRetry={() => this.setState({ error: null })}
          onReport={this.handleReport}
        />
      )
    }
    return this.props.children
  }
}
